export const EmptyClientLead = {
    lead_ID: undefined,
    companyName: '',
    url: '',
    location: '',
    noOfEmployee: 0,
    addedBy: 0,
    user_Name: '',
    createdOn: null
}